import api from './api';

const careProgramService = {
  getCarePrograms: async () => {
    const response = await api.get('/care-programs');
    return response.data;
  },

  getCareProgramById: async (id) => {
    const response = await api.get(`/care-programs/${id}`);
    return response.data;
  },

  createCareProgram: async (programData) => {
    const response = await api.post('/care-programs', programData);
    return response.data;
  },

  updateCareProgram: async (id, programData) => {
    const response = await api.patch(`/care-programs/${id}`, programData);
    return response.data;
  },

  deleteCareProgram: async (id) => {
    const response = await api.delete(`/care-programs/${id}`);
    return response.data;
  }
};

export default careProgramService;
